import {Component} from '@angular/core';
import {NavController,MenuController,Events} from 'ionic-angular';
import {LoginPage} from '../login/login';
import {RegisterPage} from "../register/register";
import {CartManager} from "../../providers/cart-manager";
import {HomePage} from "../home/home";
import {Settings} from "../../providers/settings";
import { TokenManager } from "../../providers/token-manager";

import { Storage } from '@ionic/storage';

import {Constants,ApplicationVariables} from '../../providers/config';
 import { GVLogger } from '../../services/gv-logger';
 import { RoutingInfo} from '../../providers/data';


@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html'
})
export class WelcomePage {

  constructor(public nav: NavController, private cartManager:CartManager,
    public menuController:MenuController, public settings:Settings,
    public events:Events,
    private tokenManager:TokenManager,
    private storage:Storage,
    private gVLogger:GVLogger) {



    //this.cartManager.initializeCart();
    //this.settings.setStaySignedIn(false);
    if(Constants.isWebstore){ // WEBSTORE MERGE
      this.gVLogger.log("Webstore Release");
      this.nav.setRoot(LoginPage);

      this.storage.set("cacheImages",false);

    }else{
      this.checkLoggedin().then(()=>{
      this.gVLogger.log("Login Check");
      });
    }
    this.menuController.swipeEnable(false,'sideMenu');
    this.menuController.swipeEnable(false,'testRightMenu');


      this.storage.get("negativeInventory").then((negativeInventory)=>{
       if (negativeInventory === null) {
          //...
          this.storage.set("negativeInventory",false);
        }
      });


      this.storage.get("isOfflineMode").then((off)=>{
        ApplicationVariables.isOffline = off;
        this.events.publish("ModeChanged");
      });




  }

  // go to login page
  login() {
    this.nav.push(LoginPage);
  }

  // go to register page
  register() {
    this.nav.push(RegisterPage);
  }

  checkLoggedin(){

    return new Promise(resolve => {
    this.gVLogger.log("should signed in :");
    this.gVLogger.log(this.settings.getStaySignedIn());

      this.storage.get("user").then((user)=>{
        this.gVLogger.log(user);
        if(user === null){
          this.nav.setRoot(LoginPage);
        }else{
          this.storage.get("loginRes").then((loginRes)=>{
            RoutingInfo.dt = loginRes.dtapiUrl;
            RoutingInfo.rt = loginRes.rtapiUrl;
         //user = JSON.parse(user);
          if(this.settings.getStaySignedIn()){
              this.tokenManager.setToken(user.authToken);
              this.cartManager.setSalesPerson(user);
              this.events.publish('loginSuccess');
              this.nav.setRoot(HomePage);
          }
        })
        }
        resolve(true);
      });

    });
  }






}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts